"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classnames_1 = require("classnames");
var luxon_1 = require("luxon");
var Day_1 = require("../Day");
var IconButton_1 = require("../IconButton");
var md_1 = require("react-icons/md");
var NativeSelect_1 = require("../NativeSelect");
var DatePicker_1 = require("../DatePicker");
var todayDateTime = luxon_1.DateTime.local().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
function isBetween(startDateTime, endDateTime, currentDateTime) {
    var startDateTimeSeconds = Math.min(startDateTime.valueOf(), endDateTime.valueOf());
    var endDateTimeSeconds = Math.max(startDateTime.valueOf(), endDateTime.valueOf());
    var currentDateTimeSeconds = currentDateTime.valueOf();
    return (startDateTimeSeconds < currentDateTimeSeconds && currentDateTimeSeconds < endDateTimeSeconds);
}
var DatePickerRange = /** @class */ (function (_super) {
    __extends(DatePickerRange, _super);
    function DatePickerRange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            year: DatePicker_1.currentYear,
            month: DatePicker_1.startMonth,
            virtualDateTime: null,
        };
        return _this;
    }
    DatePickerRange.prototype.render = function () {
        var _this = this;
        var _a = this.props, style = _a.style, className = _a.className, _b = _a.value, value = _b === void 0 ? [null, null] : _b, onChange = _a.onChange;
        var _c = this.state, year = _c.year, month = _c.month, virtualDateTime = _c.virtualDateTime;
        var startTime = DatePicker_1.getValidDateTime(value[0]);
        var endTime = DatePicker_1.getValidDateTime(value[1]);
        var hasStartTimeSelected = value[0] !== undefined && value[0] !== null && value[0] !== '';
        var hasEndTimeSelected = value[1] !== undefined && value[1] !== null && value[1] !== '';
        var hasSelected = hasStartTimeSelected && hasEndTimeSelected;
        var startDateTime = startTime.set({ year: year, month: month });
        var days = [];
        var firstDateTime = startDateTime.set({ day: 1 });
        var weekday = firstDateTime.weekday, daysInMonth = firstDateTime.daysInMonth;
        var startDays = weekday === 7 ? 0 : weekday;
        var _loop_1 = function (i) {
            var currentDateTime = firstDateTime.plus({ day: i });
            var isDayInMonth = firstDateTime.year === currentDateTime.year &&
                firstDateTime.month === currentDateTime.month;
            var isToday = todayDateTime.equals(currentDateTime);
            var isStartTime = hasStartTimeSelected && currentDateTime.equals(startTime);
            var isEndTime = hasEndTimeSelected && currentDateTime.equals(endTime);
            var isSelected = isStartTime || isEndTime;
            var isWeekend = currentDateTime.weekday === 7 || currentDateTime.weekday === 6;
            var isVirtualSelected = Boolean(!hasSelected &&
                hasStartTimeSelected &&
                virtualDateTime &&
                isBetween(startTime, virtualDateTime, currentDateTime));
            days.push(React.createElement(Day_1.default, { key: i, dateTime: currentDateTime, isToday: isToday, isBetween: hasSelected && isBetween(startTime, endTime, currentDateTime), isEndTime: isEndTime, isWeekend: isWeekend, isStartTime: isStartTime, isSelected: isSelected, isDayInMonth: isDayInMonth, isVirtualSelected: isVirtualSelected, onMouseEnter: function () {
                    if (hasStartTimeSelected || hasEndTimeSelected) {
                        _this.setState({ virtualDateTime: currentDateTime });
                    }
                }, onMouseLeave: function () {
                    _this.setState({ virtualDateTime: null });
                }, onClick: function () {
                    if (onChange) {
                        if (!value[0]) {
                            onChange([currentDateTime.toJSDate(), null]);
                        }
                        else if (!value[1]) {
                            var startDate = typeof value[0] === 'number' || typeof value[0] === 'string' ? null : value[0];
                            var selectedDates = [
                                startDate,
                                currentDateTime.toJSDate(),
                            ];
                            selectedDates.sort(function (a, b) {
                                return a && b ? a.getTime() - b.getTime() : 0;
                            });
                            onChange(selectedDates);
                        }
                        else {
                            onChange([currentDateTime.toJSDate(), null]);
                        }
                    }
                } }));
        };
        for (var i = -startDays; i < daysInMonth; i++) {
            _loop_1(i);
        }
        return (React.createElement("div", { style: style, className: classnames_1.default(styles.datePicker, className) },
            React.createElement("div", { className: styles.header },
                React.createElement(IconButton_1.default, { className: styles.left, onClick: function () {
                        _this.setState(DatePicker_1.getVariationDate(year, month, -1));
                    } },
                    React.createElement(md_1.MdKeyboardArrowLeft, null)),
                React.createElement("div", { className: styles.selects },
                    React.createElement(NativeSelect_1.default, { className: styles.select, options: DatePicker_1.years, value: year, onChange: function (value) {
                            _this.setState({ year: Number(value) });
                        } }),
                    React.createElement(NativeSelect_1.default, { className: styles.select, options: DatePicker_1.months, value: month, onChange: function (value) {
                            _this.setState({ month: Number(value) });
                        } })),
                React.createElement(IconButton_1.default, { className: styles.right, onClick: function () {
                        _this.setState(DatePicker_1.getVariationDate(year, month, 1));
                    } },
                    React.createElement(md_1.MdKeyboardArrowRight, null))),
            React.createElement("div", { className: styles.captions }, DatePicker_1.captions.map(function (caption) {
                return (React.createElement("div", { className: styles.caption, key: caption }, caption));
            })),
            React.createElement("div", { className: styles.days }, days)));
    };
    return DatePickerRange;
}(React.Component));
exports.default = DatePickerRange;
